__turbopack_context__.v({
  "error": "style-module-scss-module__VE5koG__error",
  "img": "style-module-scss-module__VE5koG__img",
  "imgWrapper": "style-module-scss-module__VE5koG__imgWrapper",
  "linear": "style-module-scss-module__VE5koG__linear",
  "root": "style-module-scss-module__VE5koG__root",
  "subtitle": "style-module-scss-module__VE5koG__subtitle",
  "text": "style-module-scss-module__VE5koG__text",
  "title": "style-module-scss-module__VE5koG__title",
  "wrapper": "style-module-scss-module__VE5koG__wrapper",
});
